module.exports = __webpack_public_path__ + "static/media/clientes.d27f5180.svg";